import { defineComponent as $, reactive as rt, computed as v, openBlock as E, createElementBlock as _, normalizeClass as ue, renderSlot as S, createElementVNode as y, createCommentVNode as B, inject as O, provide as j, createTextVNode as nt, toDisplayString as $e, watchEffect as N, ref as b, cloneVNode as Lt, h as x, Fragment as ot, onMounted as L, onUnmounted as M, watch as ne, shallowRef as Ot, unref as V, getCurrentInstance as Pt, Teleport as lt, nextTick as Ft, createBlock as at, withCtx as re, createVNode as K, onBeforeUnmount as Dt, Transition as At } from "vue";
const Ct = ["disabled"], Nt = /* @__PURE__ */ $({
  __name: "TEButton",
  props: {
    primary: { type: Boolean },
    disabled: { type: Boolean },
    color: {}
  },
  setup(e) {
    const t = e, { primary: r, disabled: n, color: o } = rt(t), l = {
      zinc: "bg-zinc-500 dark:bg-zinc-800 hover:bg-zinc-600 focus:bg-zinc-600 hover:bg-zinc-600 focus:bg-zinc-600 active:bg-zinc-700 hover:dark:bg-zinc-700",
      red: "bg-red-500 dark:bg-red-800 hover:bg-red-600 focus:bg-red-600 hover:bg-red-600 focus:bg-red-600 active:bg-red-700 hover:dark:bg-red-700",
      orange: "bg-orange-500 dark:bg-orange-800 hover:bg-orange-600 focus:bg-orange-600 hover:bg-orange-600 focus:bg-orange-600 active:bg-orange-700 hover:dark:bg-orange-700",
      yellow: "bg-yellow-500 dark:bg-yellow-800 hover:bg-yellow-600 focus:bg-yellow-600 hover:bg-yellow-600 focus:bg-yellow-600 active:bg-yellow-700 hover:dark:bg-yellow-700",
      green: "bg-green-500 dark:bg-green-800 hover:bg-green-600 focus:bg-green-600 hover:bg-green-600 focus:bg-green-600 active:bg-green-700 hover:dark:bg-green-700",
      teal: "bg-teal-500 dark:bg-teal-800 hover:bg-teal-600 focus:bg-teal-600 hover:bg-teal-600 focus:bg-teal-600 active:bg-teal-700 hover:dark:bg-teal-700",
      blue: "bg-blue-500 dark:bg-blue-800 hover:bg-blue-600 focus:bg-blue-600 hover:bg-blue-600 focus:bg-blue-600 active:bg-blue-700 hover:dark:bg-blue-700",
      sky: "bg-sky-500 dark:bg-sky-800 hover:bg-sky-600 focus:bg-sky-600 hover:bg-sky-600 focus:bg-sky-600 active:bg-sky-700 hover:dark:bg-sky-700",
      indigo: "bg-indigo-500 dark:bg-indigo-800 hover:bg-indigo-600 focus:bg-indigo-600 hover:bg-indigo-600 focus:bg-indigo-600 active:bg-indigo-700 hover:dark:bg-indigo-700",
      purple: "bg-purple-500 dark:bg-purple-800 hover:bg-purple-600 focus:bg-purple-600 hover:bg-purple-600 focus:bg-purple-600 active:bg-purple-700 hover:dark:bg-purple-700",
      pink: "bg-pink-500 dark:bg-pink-800 hover:bg-pink-600 focus:bg-pink-600 hover:bg-pink-600 focus:bg-pink-600 active:bg-pink-700 hover:dark:bg-pink-700",
      primary: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700",
      accent: "bg-accent-500 dark:bg-accent-800 hover:bg-accent-600 focus:bg-accent-600 hover:bg-accent-600 focus:bg-accent-600 active:bg-accent-700 hover:dark:bg-accent-700",
      rose: "bg-rose-500 dark:bg-rose-800 hover:bg-rose-600 focus:bg-rose-600 hover:bg-rose-600 focus:bg-rose-600 active:bg-rose-700 hover:dark:bg-rose-700",
      emerald: "bg-emerald-500 dark:bg-emerald-800 hover:bg-emerald-600 focus:bg-emerald-600 hover:bg-emerald-600 focus:bg-emerald-600 active:bg-emerald-700 hover:dark:bg-emerald-700"
    }, a = v(() => l[o ?? "primary"]);
    return (i, s) => (E(), _("button", {
      type: "button",
      disabled: t.disabled,
      class: ue([t.disabled ? "cursor-not-allowed bg-gray-500" : a.value, "inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"])
    }, [
      S(i.$slots, "default")
    ], 10, Ct));
  }
}), xe = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, Bt = {}, jt = { class: "flex w-full justify-center" }, Mt = { class: "max-w-8xl w-full rounded bg-white p-4 shadow dark:border-primary-400 dark:bg-zinc-800" }, Rt = {
  key: 0,
  class: "-mx-4 -mb-4 mt-5 border-t-2 bg-gray-50 px-4 pb-4 dark:border-primary-400 dark:bg-primary-800"
}, Ht = { class: "flex justify-end pt-4" };
function zt(e, t) {
  return E(), _("div", jt, [
    y("div", Mt, [
      S(e.$slots, "default"),
      e.$slots.actions ? (E(), _("div", Rt, [
        y("div", Ht, [
          S(e.$slots, "actions")
        ])
      ])) : B("", !0)
    ])
  ]);
}
const It = /* @__PURE__ */ xe(Bt, [["render", zt]]), Ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: It
}, Symbol.toStringTag, { value: "Module" })), Vt = ["id", "value", "type", "placeholder"], Bn = /* @__PURE__ */ $({
  __name: "TETextInput",
  props: {
    name: {},
    placeholder: {},
    required: { type: Boolean },
    type: {},
    modelValue: {},
    error: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    function o(i) {
      const s = i.target;
      n("update:modelValue", s.value);
    }
    const l = v(() => O(`error-${r.name}`)), a = v(() => l.value.value ? "border-red-500" : "border-gray-400");
    return (i, s) => (E(), _("input", {
      id: i.name,
      value: i.modelValue,
      type: i.type ?? "text",
      placeholder: i.placeholder,
      class: ue(["block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 outline-0 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-0 focus:ring-2 focus:ring-inset focus:ring-primary-600 focus:transition-all sm:text-sm sm:leading-6 dark:bg-zinc-600 dark:text-white dark:ring-zinc-900 focus:dark:ring-primary-900", a.value]),
      onInput: o
    }, null, 42, Vt));
  }
}), Wt = { class: "py-2" }, qt = ["for"], Gt = {
  key: 0,
  class: "text-red-500"
}, Yt = { class: "" }, Kt = {
  key: 0,
  class: "text-sm text-red-600"
}, jn = /* @__PURE__ */ $({
  __name: "TETopLabelLayout",
  props: {
    title: {},
    required: { type: Boolean },
    name: {},
    error: {}
  },
  setup(e) {
    const t = e, r = v(() => t.error ?? void 0);
    return j(
      `error-${t.name}`,
      v(() => r.value ?? void 0)
    ), (n, o) => (E(), _("div", Wt, [
      y("label", {
        for: n.name,
        class: "block text-sm font-medium leading-6 text-gray-900 dark:text-gray-300"
      }, [
        nt($e(n.title), 1),
        n.required ? (E(), _("span", Gt, "*")) : B("", !0)
      ], 8, qt),
      y("div", Yt, [
        S(n.$slots, "default", { class: "block w-full" })
      ]),
      r.value ? (E(), _("div", Kt, $e(r.value), 1)) : B("", !0)
    ]));
  }
}), Mn = /* @__PURE__ */ $({
  __name: "TEBadge",
  props: {
    type: {}
  },
  setup(e) {
    const t = e, r = {
      white: "bg-zinc-200/40 text-zinc-800 border-zinc-300 dark:border-zinc-700 dark:bg-zinc-700/50 dark:text-zinc-200",
      accent: "bg-accent-200/40 text-accent-800 border-accent-300 dark:border-accent-700 dark:bg-accent-700/50 dark:text-accent-200",
      red: "bg-red-200/40 text-red-800 border-red-300 dark:border-red-700 dark:bg-red-900/50 dark:border-red-900 dark:text-red-500",
      orange: "bg-orange-200/40 text-orange-800 border-orange-300 dark:border-orange-700 dark:bg-orange-900/50 dark:text-orange-500",
      yellow: "bg-yellow-200/40 text-yellow-800 border-yellow-300 dark:border-yellow-700 dark:bg-yellow-900/50 dark:text-yellow-500",
      green: "bg-green-200/40 text-green-800 border-green-300 dark:border-green-700 dark:bg-green-900/50 dark:text-green-500",
      teal: "bg-teal-200/40 text-teal-800 border-teal-300 dark:border-teal-700 dark:bg-teal-900/50 dark:text-teal-500",
      blue: "bg-blue-200/40 text-blue-800 border-blue-300 dark:border-blue-700 dark:bg-blue-900/50 dark:text-blue-500",
      sky: "bg-sky-200/40 text-sky-800 border-sky-300 dark:border-sky-700 dark:bg-sky-900/50 dark:text-sky-500",
      indigo: "bg-indigo-200/40 text-indigo-800 border-indigo-300 dark:border-indigo-700 dark:bg-indigo-900/60 dark:text-indigo-400",
      purple: "bg-purple-200/40 text-purple-800 border-purple-300 dark:border-purple-700 dark:bg-purple-900/60 dark:text-purple-400",
      pink: "bg-pink-200/40 text-pink-800 border-pink-300 dark:border-pink-700 dark:bg-pink-900/50 dark:text-pink-500",
      primary: "bg-primary-200/40 text-primary-800 border-primary-300 dark:border-primary-700 dark:bg-primary-900/50 dark:text-primary-500",
      rose: "bg-rose-200/40 text-rose-800 border-rose-300 dark:border-rose-700 dark:bg-rose-900/50 dark:text-rose-500",
      emerald: "bg-emerald-200/40 text-emerald-800 border-emerald-300 dark:border-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-500"
    }, n = v(() => r[t.type]);
    return (o, l) => (E(), _("span", {
      class: ue([n.value, "rounded-full p-1 px-2"])
    }, [
      S(o.$slots, "default")
    ], 2));
  }
});
let Xt = Symbol("headlessui.useid"), Qt = 0;
function J() {
  return O(Xt, () => `${++Qt}`)();
}
function T(e) {
  var t;
  if (e == null || e.value == null)
    return null;
  let r = (t = e.value.$el) != null ? t : e.value;
  return r instanceof Node ? r : null;
}
function z(e, t, ...r) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...r) : o;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, z), n;
}
var Zt = Object.defineProperty, Jt = (e, t, r) => t in e ? Zt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Qe = (e, t, r) => (Jt(e, typeof t != "symbol" ? t + "" : t, r), r);
let er = class {
  constructor() {
    Qe(this, "current", this.detect()), Qe(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, de = new er();
function oe(e) {
  if (de.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = T(e);
    if (t)
      return t.ownerDocument;
  }
  return document;
}
let Ne = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var W = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(W || {}), it = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(it || {}), tr = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(tr || {});
function rr(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ne)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var st = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(st || {});
function nr(e, t = 0) {
  var r;
  return e === ((r = oe(e)) == null ? void 0 : r.body) ? !1 : z(t, { 0() {
    return e.matches(Ne);
  }, 1() {
    let n = e;
    for (; n !== null; ) {
      if (n.matches(Ne))
        return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
var or = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(or || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Z(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let lr = ["textarea", "input"].join(",");
function ar(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, lr)) != null ? r : !1;
}
function ir(e, t = (r) => r) {
  return e.slice().sort((r, n) => {
    let o = t(r), l = t(n);
    if (o === null || l === null)
      return 0;
    let a = o.compareDocumentPosition(l);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Ee(e, t, { sorted: r = !0, relativeTo: n = null, skipElements: o = [] } = {}) {
  var l;
  let a = (l = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? l : document, i = Array.isArray(e) ? r ? ir(e) : e : rr(e);
  o.length > 0 && i.length > 1 && (i = i.filter((p) => !o.includes(p))), n = n ?? a.activeElement;
  let s = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, i.indexOf(n)) - 1;
    if (t & 4)
      return Math.max(0, i.indexOf(n)) + 1;
    if (t & 8)
      return i.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = t & 32 ? { preventScroll: !0 } : {}, g = 0, c = i.length, f;
  do {
    if (g >= c || g + c <= 0)
      return 0;
    let p = u + g;
    if (t & 16)
      p = (p + c) % c;
    else {
      if (p < 0)
        return 3;
      if (p >= c)
        return 1;
    }
    f = i[p], f == null || f.focus(d), g += s;
  } while (f !== a.activeElement);
  return t & 6 && ar(f) && f.select(), 2;
}
function ut() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function sr() {
  return /Android/gi.test(window.navigator.userAgent);
}
function ur() {
  return ut() || sr();
}
function ye(e, t, r) {
  de.isServer || N((n) => {
    document.addEventListener(e, t, r), n(() => document.removeEventListener(e, t, r));
  });
}
function dt(e, t, r) {
  de.isServer || N((n) => {
    window.addEventListener(e, t, r), n(() => window.removeEventListener(e, t, r));
  });
}
function dr(e, t, r = v(() => !0)) {
  function n(l, a) {
    if (!r.value || l.defaultPrevented)
      return;
    let i = a(l);
    if (i === null || !i.getRootNode().contains(i))
      return;
    let s = function u(d) {
      return typeof d == "function" ? u(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e);
    for (let u of s) {
      if (u === null)
        continue;
      let d = u instanceof HTMLElement ? u : T(u);
      if (d != null && d.contains(i) || l.composed && l.composedPath().includes(d))
        return;
    }
    return !nr(i, st.Loose) && i.tabIndex !== -1 && l.preventDefault(), t(l, i);
  }
  let o = b(null);
  ye("pointerdown", (l) => {
    var a, i;
    r.value && (o.value = ((i = (a = l.composedPath) == null ? void 0 : a.call(l)) == null ? void 0 : i[0]) || l.target);
  }, !0), ye("mousedown", (l) => {
    var a, i;
    r.value && (o.value = ((i = (a = l.composedPath) == null ? void 0 : a.call(l)) == null ? void 0 : i[0]) || l.target);
  }, !0), ye("click", (l) => {
    ur() || o.value && (n(l, () => o.value), o.value = null);
  }, !0), ye("touchend", (l) => n(l, () => l.target instanceof HTMLElement ? l.target : null), !0), dt("blur", (l) => n(l, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var Te = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Te || {}), q = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(q || {});
function D({ visible: e = !0, features: t = 0, ourProps: r, theirProps: n, ...o }) {
  var l;
  let a = pt(n, r), i = Object.assign(o, { props: a });
  if (e || t & 2 && a.static)
    return De(i);
  if (t & 1) {
    let s = (l = a.unmount) == null || l ? 0 : 1;
    return z(s, { 0() {
      return null;
    }, 1() {
      return De({ ...o, props: { ...a, hidden: !0, style: { display: "none" } } });
    } });
  }
  return De(i);
}
function De({ props: e, attrs: t, slots: r, slot: n, name: o }) {
  var l, a;
  let { as: i, ...s } = ft(e, ["unmount", "static"]), u = (l = r.default) == null ? void 0 : l.call(r, n), d = {};
  if (n) {
    let g = !1, c = [];
    for (let [f, p] of Object.entries(n))
      typeof p == "boolean" && (g = !0), p === !0 && c.push(f);
    g && (d["data-headlessui-state"] = c.join(" "));
  }
  if (i === "template") {
    if (u = ct(u ?? []), Object.keys(s).length > 0 || Object.keys(t).length > 0) {
      let [g, ...c] = u ?? [];
      if (!cr(g) || c.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${o} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(s).concat(Object.keys(t)).map((m) => m.trim()).filter((m, w, R) => R.indexOf(m) === w).sort((m, w) => m.localeCompare(w)).map((m) => `  - ${m}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((m) => `  - ${m}`).join(`
`)].join(`
`));
      let f = pt((a = g.props) != null ? a : {}, s, d), p = Lt(g, f, !0);
      for (let m in f)
        m.startsWith("on") && (p.props || (p.props = {}), p.props[m] = f[m]);
      return p;
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return x(i, Object.assign({}, s, d), { default: () => u });
}
function ct(e) {
  return e.flatMap((t) => t.type === ot ? ct(t.children) : [t]);
}
function pt(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, r = {};
  for (let n of e)
    for (let o in n)
      o.startsWith("on") && typeof n[o] == "function" ? (r[o] != null || (r[o] = []), r[o].push(n[o])) : t[o] = n[o];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(r).map((n) => [n, void 0])));
  for (let n in r)
    Object.assign(t, { [n](o, ...l) {
      let a = r[n];
      for (let i of a) {
        if (o instanceof Event && o.defaultPrevented)
          return;
        i(o, ...l);
      }
    } });
  return t;
}
function ft(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t)
    n in r && delete r[n];
  return r;
}
function cr(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var _e = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(_e || {});
let Be = $({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: r }) {
  return () => {
    var n;
    let { features: o, ...l } = e, a = { "aria-hidden": (o & 2) === 2 ? !0 : (n = l["aria-hidden"]) != null ? n : void 0, hidden: (o & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
    return D({ ourProps: a, theirProps: l, slot: {}, attrs: r, slots: t, name: "Hidden" });
  };
} }), vt = Symbol("Context");
var F = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(F || {});
function pr() {
  return Ve() !== null;
}
function Ve() {
  return O(vt, null);
}
function fr(e) {
  j(vt, e);
}
var gt = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(gt || {});
function vr(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let X = [];
vr(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && X[0] !== t.target && (X.unshift(t.target), X = X.filter((r) => r != null && r.isConnected), X.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function We(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function ce() {
  let e = [], t = { addEventListener(r, n, o, l) {
    return r.addEventListener(n, o, l), t.add(() => r.removeEventListener(n, o, l));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    t.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...r);
    });
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    t.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return We(() => {
      n.current && r[0]();
    }), t.add(() => {
      n.current = !1;
    });
  }, style(r, n, o) {
    let l = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: o }), this.add(() => {
      Object.assign(r.style, { [n]: l });
    });
  }, group(r) {
    let n = ce();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return e.push(r), () => {
      let n = e.indexOf(r);
      if (n >= 0)
        for (let o of e.splice(n, 1))
          o();
    };
  }, dispose() {
    for (let r of e.splice(0))
      r();
  } };
  return t;
}
function mt(e, t, r, n) {
  de.isServer || N((o) => {
    e = e ?? window, e.addEventListener(t, r, n), o(() => e.removeEventListener(t, r, n));
  });
}
var se = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(se || {});
function gr() {
  let e = b(0);
  return dt("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function bt(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let r of e.value) {
    let n = T(r);
    n instanceof HTMLElement && t.add(n);
  }
  return t;
}
var ht = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(ht || {});
let ae = Object.assign($({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: b(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: n }) {
  let o = b(null);
  n({ el: o, $el: o });
  let l = v(() => oe(o)), a = b(!1);
  L(() => a.value = !0), M(() => a.value = !1), br({ ownerDocument: l }, v(() => a.value && !!(e.features & 16)));
  let i = hr({ ownerDocument: l, container: o, initialFocus: v(() => e.initialFocus) }, v(() => a.value && !!(e.features & 2)));
  yr({ ownerDocument: l, container: o, containers: e.containers, previousActiveElement: i }, v(() => a.value && !!(e.features & 8)));
  let s = gr();
  function u(f) {
    let p = T(o);
    p && ((m) => m())(() => {
      z(s.value, { [se.Forwards]: () => {
        Ee(p, W.First, { skipElements: [f.relatedTarget] });
      }, [se.Backwards]: () => {
        Ee(p, W.Last, { skipElements: [f.relatedTarget] });
      } });
    });
  }
  let d = b(!1);
  function g(f) {
    f.key === "Tab" && (d.value = !0, requestAnimationFrame(() => {
      d.value = !1;
    }));
  }
  function c(f) {
    if (!a.value)
      return;
    let p = bt(e.containers);
    T(o) instanceof HTMLElement && p.add(T(o));
    let m = f.relatedTarget;
    m instanceof HTMLElement && m.dataset.headlessuiFocusGuard !== "true" && (yt(p, m) || (d.value ? Ee(T(o), z(s.value, { [se.Forwards]: () => W.Next, [se.Backwards]: () => W.Previous }) | W.WrapAround, { relativeTo: f.target }) : f.target instanceof HTMLElement && Z(f.target)));
  }
  return () => {
    let f = {}, p = { ref: o, onKeydown: g, onFocusout: c }, { features: m, initialFocus: w, containers: R, ...P } = e;
    return x(ot, [!!(m & 4) && x(Be, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: _e.Focusable }), D({ ourProps: p, theirProps: { ...t, ...P }, slot: f, attrs: t, slots: r, name: "FocusTrap" }), !!(m & 4) && x(Be, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: _e.Focusable })]);
  };
} }), { features: ht });
function mr(e) {
  let t = b(X.slice());
  return ne([e], ([r], [n]) => {
    n === !0 && r === !1 ? We(() => {
      t.value.splice(0);
    }) : n === !1 && r === !0 && (t.value = X.slice());
  }, { flush: "post" }), () => {
    var r;
    return (r = t.value.find((n) => n != null && n.isConnected)) != null ? r : null;
  };
}
function br({ ownerDocument: e }, t) {
  let r = mr(t);
  L(() => {
    N(() => {
      var n, o;
      t.value || ((n = e.value) == null ? void 0 : n.activeElement) === ((o = e.value) == null ? void 0 : o.body) && Z(r());
    }, { flush: "post" });
  }), M(() => {
    t.value && Z(r());
  });
}
function hr({ ownerDocument: e, container: t, initialFocus: r }, n) {
  let o = b(null), l = b(!1);
  return L(() => l.value = !0), M(() => l.value = !1), L(() => {
    ne([t, r, n], (a, i) => {
      if (a.every((u, d) => (i == null ? void 0 : i[d]) === u) || !n.value)
        return;
      let s = T(t);
      s && We(() => {
        var u, d;
        if (!l.value)
          return;
        let g = T(r), c = (u = e.value) == null ? void 0 : u.activeElement;
        if (g) {
          if (g === c) {
            o.value = c;
            return;
          }
        } else if (s.contains(c)) {
          o.value = c;
          return;
        }
        g ? Z(g) : Ee(s, W.First | W.NoScroll) === it.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.value = (d = e.value) == null ? void 0 : d.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), o;
}
function yr({ ownerDocument: e, container: t, containers: r, previousActiveElement: n }, o) {
  var l;
  mt((l = e.value) == null ? void 0 : l.defaultView, "focus", (a) => {
    if (!o.value)
      return;
    let i = bt(r);
    T(t) instanceof HTMLElement && i.add(T(t));
    let s = n.value;
    if (!s)
      return;
    let u = a.target;
    u && u instanceof HTMLElement ? yt(i, u) ? (n.value = u, Z(u)) : (a.preventDefault(), a.stopPropagation(), Z(s)) : Z(n.value);
  }, !0);
}
function yt(e, t) {
  for (let r of e)
    if (r.contains(t))
      return !0;
  return !1;
}
function wr(e) {
  let t = Ot(e.getSnapshot());
  return M(e.subscribe(() => {
    t.value = e.getSnapshot();
  })), t;
}
function kr(e, t) {
  let r = e(), n = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(o) {
    return n.add(o), () => n.delete(o);
  }, dispatch(o, ...l) {
    let a = t[o].call(r, ...l);
    a && (r = a, n.forEach((i) => i()));
  } };
}
function Er() {
  let e;
  return { before({ doc: t }) {
    var r;
    let n = t.documentElement;
    e = ((r = t.defaultView) != null ? r : window).innerWidth - n.clientWidth;
  }, after({ doc: t, d: r }) {
    let n = t.documentElement, o = n.clientWidth - n.offsetWidth, l = e - o;
    r.style(n, "paddingRight", `${l}px`);
  } };
}
function $r() {
  return ut() ? { before({ doc: e, d: t, meta: r }) {
    function n(o) {
      return r.containers.flatMap((l) => l()).some((l) => l.contains(o));
    }
    t.microTask(() => {
      var o;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let i = ce();
        i.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => i.dispose()));
      }
      let l = (o = window.scrollY) != null ? o : window.pageYOffset, a = null;
      t.addEventListener(e, "click", (i) => {
        if (i.target instanceof HTMLElement)
          try {
            let s = i.target.closest("a");
            if (!s)
              return;
            let { hash: u } = new URL(s.href), d = e.querySelector(u);
            d && !n(d) && (a = d);
          } catch {
          }
      }, !0), t.addEventListener(e, "touchstart", (i) => {
        if (i.target instanceof HTMLElement)
          if (n(i.target)) {
            let s = i.target;
            for (; s.parentElement && n(s.parentElement); )
              s = s.parentElement;
            t.style(s, "overscrollBehavior", "contain");
          } else
            t.style(i.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (i) => {
        if (i.target instanceof HTMLElement)
          if (n(i.target)) {
            let s = i.target;
            for (; s.parentElement && s.dataset.headlessuiPortal !== "" && !(s.scrollHeight > s.clientHeight || s.scrollWidth > s.clientWidth); )
              s = s.parentElement;
            s.dataset.headlessuiPortal === "" && i.preventDefault();
          } else
            i.preventDefault();
      }, { passive: !1 }), t.add(() => {
        var i;
        let s = (i = window.scrollY) != null ? i : window.pageYOffset;
        l !== s && window.scrollTo(0, l), a && a.isConnected && (a.scrollIntoView({ block: "nearest" }), a = null);
      });
    });
  } } : {};
}
function Tr() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function _r(e) {
  let t = {};
  for (let r of e)
    Object.assign(t, r(t));
  return t;
}
let Q = kr(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var r;
  let n = (r = this.get(e)) != null ? r : { doc: e, count: 0, d: ce(), meta: /* @__PURE__ */ new Set() };
  return n.count++, n.meta.add(t), this.set(e, n), this;
}, POP(e, t) {
  let r = this.get(e);
  return r && (r.count--, r.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: r }) {
  let n = { doc: e, d: t, meta: _r(r) }, o = [$r(), Er(), Tr()];
  o.forEach(({ before: l }) => l == null ? void 0 : l(n)), o.forEach(({ after: l }) => l == null ? void 0 : l(n));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
Q.subscribe(() => {
  let e = Q.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [r] of e)
    t.set(r, r.documentElement.style.overflow);
  for (let r of e.values()) {
    let n = t.get(r.doc) === "hidden", o = r.count !== 0;
    (o && !n || !o && n) && Q.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && Q.dispatch("TEARDOWN", r);
  }
});
function xr(e, t, r) {
  let n = wr(Q), o = v(() => {
    let l = e.value ? n.value.get(e.value) : void 0;
    return l ? l.count > 0 : !1;
  });
  return ne([e, t], ([l, a], [i], s) => {
    if (!l || !a)
      return;
    Q.dispatch("PUSH", l, r);
    let u = !1;
    s(() => {
      u || (Q.dispatch("POP", i ?? l, r), u = !0);
    });
  }, { immediate: !0 }), o;
}
let Ae = /* @__PURE__ */ new Map(), ie = /* @__PURE__ */ new Map();
function Ze(e, t = b(!0)) {
  N((r) => {
    var n;
    if (!t.value)
      return;
    let o = T(e);
    if (!o)
      return;
    r(function() {
      var a;
      if (!o)
        return;
      let i = (a = ie.get(o)) != null ? a : 1;
      if (i === 1 ? ie.delete(o) : ie.set(o, i - 1), i !== 1)
        return;
      let s = Ae.get(o);
      s && (s["aria-hidden"] === null ? o.removeAttribute("aria-hidden") : o.setAttribute("aria-hidden", s["aria-hidden"]), o.inert = s.inert, Ae.delete(o));
    });
    let l = (n = ie.get(o)) != null ? n : 0;
    ie.set(o, l + 1), l === 0 && (Ae.set(o, { "aria-hidden": o.getAttribute("aria-hidden"), inert: o.inert }), o.setAttribute("aria-hidden", "true"), o.inert = !0);
  });
}
function Sr({ defaultContainers: e = [], portals: t, mainTreeNodeRef: r } = {}) {
  let n = b(null), o = oe(n);
  function l() {
    var a, i, s;
    let u = [];
    for (let d of e)
      d !== null && (d instanceof HTMLElement ? u.push(d) : "value" in d && d.value instanceof HTMLElement && u.push(d.value));
    if (t != null && t.value)
      for (let d of t.value)
        u.push(d);
    for (let d of (a = o == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? a : [])
      d !== document.body && d !== document.head && d instanceof HTMLElement && d.id !== "headlessui-portal-root" && (d.contains(T(n)) || d.contains((s = (i = T(n)) == null ? void 0 : i.getRootNode()) == null ? void 0 : s.host) || u.some((g) => d.contains(g)) || u.push(d));
    return u;
  }
  return { resolveContainers: l, contains(a) {
    return l().some((i) => i.contains(a));
  }, mainTreeNodeRef: n, MainTreeNode() {
    return r != null ? null : x(Be, { features: _e.Hidden, ref: n });
  } };
}
let wt = Symbol("ForcePortalRootContext");
function Lr() {
  return O(wt, !1);
}
let je = $({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: r }) {
  return j(wt, e.force), () => {
    let { force: n, ...o } = e;
    return D({ theirProps: o, ourProps: {}, slot: {}, slots: t, attrs: r, name: "ForcePortalRoot" });
  };
} }), kt = Symbol("StackContext");
var Me = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(Me || {});
function Or() {
  return O(kt, () => {
  });
}
function Pr({ type: e, enabled: t, element: r, onUpdate: n }) {
  let o = Or();
  function l(...a) {
    n == null || n(...a), o(...a);
  }
  L(() => {
    ne(t, (a, i) => {
      a ? l(0, e, r) : i === !0 && l(1, e, r);
    }, { immediate: !0, flush: "sync" });
  }), M(() => {
    t.value && l(1, e, r);
  }), j(kt, l);
}
let Et = Symbol("DescriptionContext");
function Fr() {
  let e = O(Et, null);
  if (e === null)
    throw new Error("Missing parent");
  return e;
}
function Dr({ slot: e = b({}), name: t = "Description", props: r = {} } = {}) {
  let n = b([]);
  function o(l) {
    return n.value.push(l), () => {
      let a = n.value.indexOf(l);
      a !== -1 && n.value.splice(a, 1);
    };
  }
  return j(Et, { register: o, slot: e, name: t, props: r }), v(() => n.value.length > 0 ? n.value.join(" ") : void 0);
}
$({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let o = (n = e.id) != null ? n : `headlessui-description-${J()}`, l = Fr();
  return L(() => M(l.register(o))), () => {
    let { name: a = "Description", slot: i = b({}), props: s = {} } = l, { ...u } = e, d = { ...Object.entries(s).reduce((g, [c, f]) => Object.assign(g, { [c]: V(f) }), {}), id: o };
    return D({ ourProps: d, theirProps: u, slot: i.value, attrs: t, slots: r, name: a });
  };
} });
function Ar(e) {
  let t = oe(e);
  if (!t) {
    if (e === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let r = t.getElementById("headlessui-portal-root");
  if (r)
    return r;
  let n = t.createElement("div");
  return n.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(n);
}
const Re = /* @__PURE__ */ new WeakMap();
function Cr(e) {
  var t;
  return (t = Re.get(e)) != null ? t : 0;
}
function Je(e, t) {
  let r = t(Cr(e));
  return r <= 0 ? Re.delete(e) : Re.set(e, r), r;
}
let $t = $({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: r }) {
  let n = b(null), o = v(() => oe(n)), l = Lr(), a = O(Tt, null), i = b(l === !0 || a == null ? Ar(n.value) : a.resolveTarget());
  i.value && Je(i.value, (c) => c + 1);
  let s = b(!1);
  L(() => {
    s.value = !0;
  }), N(() => {
    l || a != null && (i.value = a.resolveTarget());
  });
  let u = O(He, null), d = !1, g = Pt();
  return ne(n, () => {
    if (d || !u)
      return;
    let c = T(n);
    c && (M(u.register(c), g), d = !0);
  }), M(() => {
    var c, f;
    let p = (c = o.value) == null ? void 0 : c.getElementById("headlessui-portal-root");
    !p || i.value !== p || Je(i.value, (m) => m - 1) || i.value.children.length > 0 || (f = i.value.parentElement) == null || f.removeChild(i.value);
  }), () => {
    if (!s.value || i.value === null)
      return null;
    let c = { ref: n, "data-headlessui-portal": "" };
    return x(lt, { to: i.value }, D({ ourProps: c, theirProps: e, slot: {}, attrs: r, slots: t, name: "Portal" }));
  };
} }), He = Symbol("PortalParentContext");
function Nr() {
  let e = O(He, null), t = b([]);
  function r(l) {
    return t.value.push(l), e && e.register(l), () => n(l);
  }
  function n(l) {
    let a = t.value.indexOf(l);
    a !== -1 && t.value.splice(a, 1), e && e.unregister(l);
  }
  let o = { register: r, unregister: n, portals: t };
  return [t, $({ name: "PortalWrapper", setup(l, { slots: a }) {
    return j(He, o), () => {
      var i;
      return (i = a.default) == null ? void 0 : i.call(a);
    };
  } })];
}
let Tt = Symbol("PortalGroupContext"), Br = $({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: r }) {
  let n = rt({ resolveTarget() {
    return e.target;
  } });
  return j(Tt, n), () => {
    let { target: o, ...l } = e;
    return D({ theirProps: l, ourProps: {}, slot: {}, attrs: t, slots: r, name: "PortalGroup" });
  };
} });
var jr = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(jr || {});
let ze = Symbol("DialogContext");
function pe(e) {
  let t = O(ze, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, pe), r;
  }
  return t;
}
let we = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", Mr = $({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: we }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: t, attrs: r, slots: n, expose: o }) {
  var l, a;
  let i = (l = e.id) != null ? l : `headlessui-dialog-${J()}`, s = b(!1);
  L(() => {
    s.value = !0;
  });
  let u = !1, d = v(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (u || (u = !0, console.warn(`Invalid role [${d}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), g = b(0), c = Ve(), f = v(() => e.open === we && c !== null ? (c.value & F.Open) === F.Open : e.open), p = b(null), m = v(() => oe(p));
  if (o({ el: p, $el: p }), !(e.open !== we || c !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof f.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${f.value === we ? void 0 : e.open}`);
  let w = v(() => s.value && f.value ? 0 : 1), R = v(() => w.value === 0), P = v(() => g.value > 1), G = O(ze, null) !== null, [fe, ve] = Nr(), { resolveContainers: ee, mainTreeNodeRef: ge, MainTreeNode: me } = Sr({ portals: fe, defaultContainers: [v(() => {
    var h;
    return (h = te.panelRef.value) != null ? h : p.value;
  })] }), Le = v(() => P.value ? "parent" : "leaf"), be = v(() => c !== null ? (c.value & F.Closing) === F.Closing : !1), Oe = v(() => G || be.value ? !1 : R.value), Pe = v(() => {
    var h, k, A;
    return (A = Array.from((k = (h = m.value) == null ? void 0 : h.querySelectorAll("body > *")) != null ? k : []).find((C) => C.id === "headlessui-portal-root" ? !1 : C.contains(T(ge)) && C instanceof HTMLElement)) != null ? A : null;
  });
  Ze(Pe, Oe);
  let H = v(() => P.value ? !0 : R.value), le = v(() => {
    var h, k, A;
    return (A = Array.from((k = (h = m.value) == null ? void 0 : h.querySelectorAll("[data-headlessui-portal]")) != null ? k : []).find((C) => C.contains(T(ge)) && C instanceof HTMLElement)) != null ? A : null;
  });
  Ze(le, H), Pr({ type: "Dialog", enabled: v(() => w.value === 0), element: p, onUpdate: (h, k) => {
    if (k === "Dialog")
      return z(h, { [Me.Add]: () => g.value += 1, [Me.Remove]: () => g.value -= 1 });
  } });
  let I = Dr({ name: "DialogDescription", slot: v(() => ({ open: f.value })) }), U = b(null), te = { titleId: U, panelRef: b(null), dialogState: w, setTitleId(h) {
    U.value !== h && (U.value = h);
  }, close() {
    t("close", !1);
  } };
  j(ze, te);
  let Ye = v(() => !(!R.value || P.value));
  dr(ee, (h, k) => {
    h.preventDefault(), te.close(), Ft(() => k == null ? void 0 : k.focus());
  }, Ye);
  let Ke = v(() => !(P.value || w.value !== 0));
  mt((a = m.value) == null ? void 0 : a.defaultView, "keydown", (h) => {
    Ke.value && (h.defaultPrevented || h.key === gt.Escape && (h.preventDefault(), h.stopPropagation(), te.close()));
  });
  let Xe = v(() => !(be.value || w.value !== 0 || G));
  return xr(m, Xe, (h) => {
    var k;
    return { containers: [...(k = h.containers) != null ? k : [], ee] };
  }), N((h) => {
    if (w.value !== 0)
      return;
    let k = T(p);
    if (!k)
      return;
    let A = new ResizeObserver((C) => {
      for (let Fe of C) {
        let he = Fe.target.getBoundingClientRect();
        he.x === 0 && he.y === 0 && he.width === 0 && he.height === 0 && te.close();
      }
    });
    A.observe(k), h(() => A.disconnect());
  }), () => {
    let { open: h, initialFocus: k, ...A } = e, C = { ...r, ref: p, id: i, role: d.value, "aria-modal": w.value === 0 ? !0 : void 0, "aria-labelledby": U.value, "aria-describedby": I.value }, Fe = { open: w.value === 0 };
    return x(je, { force: !0 }, () => [x($t, () => x(Br, { target: p.value }, () => x(je, { force: !1 }, () => x(ae, { initialFocus: k, containers: ee, features: R.value ? z(Le.value, { parent: ae.features.RestoreFocus, leaf: ae.features.All & ~ae.features.FocusLock }) : ae.features.None }, () => x(ve, {}, () => D({ ourProps: C, theirProps: { ...A, ...r }, slot: Fe, attrs: r, slots: n, visible: w.value === 0, features: Te.RenderStrategy | Te.Static, name: "Dialog" })))))), x(me)]);
  };
} });
$({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let o = (n = e.id) != null ? n : `headlessui-dialog-overlay-${J()}`, l = pe("DialogOverlay");
  function a(i) {
    i.target === i.currentTarget && (i.preventDefault(), i.stopPropagation(), l.close());
  }
  return () => {
    let { ...i } = e;
    return D({ ourProps: { id: o, "aria-hidden": !0, onClick: a }, theirProps: i, slot: { open: l.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogOverlay" });
  };
} });
$({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: n }) {
  var o;
  let l = (o = e.id) != null ? o : `headlessui-dialog-backdrop-${J()}`, a = pe("DialogBackdrop"), i = b(null);
  return n({ el: i, $el: i }), L(() => {
    if (a.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...s } = e, u = { id: l, ref: i, "aria-hidden": !0 };
    return x(je, { force: !0 }, () => x($t, () => D({ ourProps: u, theirProps: { ...t, ...s }, slot: { open: a.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogBackdrop" })));
  };
} });
let Rr = $({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: n }) {
  var o;
  let l = (o = e.id) != null ? o : `headlessui-dialog-panel-${J()}`, a = pe("DialogPanel");
  n({ el: a.panelRef, $el: a.panelRef });
  function i(s) {
    s.stopPropagation();
  }
  return () => {
    let { ...s } = e, u = { id: l, ref: a.panelRef, onClick: i };
    return D({ ourProps: u, theirProps: s, slot: { open: a.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogPanel" });
  };
} }), Hr = $({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let o = (n = e.id) != null ? n : `headlessui-dialog-title-${J()}`, l = pe("DialogTitle");
  return L(() => {
    l.setTitleId(o), M(() => l.setTitleId(null));
  }), () => {
    let { ...a } = e;
    return D({ ourProps: { id: o }, theirProps: a, slot: { open: l.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogTitle" });
  };
} });
function zr(e) {
  let t = { called: !1 };
  return (...r) => {
    if (!t.called)
      return t.called = !0, e(...r);
  };
}
function Ce(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function ke(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var Ie = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(Ie || {});
function Ir(e, t) {
  let r = ce();
  if (!e)
    return r.dispose;
  let { transitionDuration: n, transitionDelay: o } = getComputedStyle(e), [l, a] = [n, o].map((i) => {
    let [s = 0] = i.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, d) => d - u);
    return s;
  });
  return l !== 0 ? r.setTimeout(() => t("finished"), l + a) : t("finished"), r.add(() => t("cancelled")), r.dispose;
}
function et(e, t, r, n, o, l) {
  let a = ce(), i = l !== void 0 ? zr(l) : () => {
  };
  return ke(e, ...o), Ce(e, ...t, ...r), a.nextFrame(() => {
    ke(e, ...r), Ce(e, ...n), a.add(Ir(e, (s) => (ke(e, ...n, ...t), Ce(e, ...o), i(s))));
  }), a.add(() => ke(e, ...t, ...r, ...n, ...o)), a.add(() => i("cancelled")), a.dispose;
}
function Y(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let qe = Symbol("TransitionContext");
var Ur = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(Ur || {});
function Vr() {
  return O(qe, null) !== null;
}
function Wr() {
  let e = O(qe, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function qr() {
  let e = O(Ge, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let Ge = Symbol("NestingContext");
function Se(e) {
  return "children" in e ? Se(e.children) : e.value.filter(({ state: t }) => t === "visible").length > 0;
}
function _t(e) {
  let t = b([]), r = b(!1);
  L(() => r.value = !0), M(() => r.value = !1);
  function n(l, a = q.Hidden) {
    let i = t.value.findIndex(({ id: s }) => s === l);
    i !== -1 && (z(a, { [q.Unmount]() {
      t.value.splice(i, 1);
    }, [q.Hidden]() {
      t.value[i].state = "hidden";
    } }), !Se(t) && r.value && (e == null || e()));
  }
  function o(l) {
    let a = t.value.find(({ id: i }) => i === l);
    return a ? a.state !== "visible" && (a.state = "visible") : t.value.push({ id: l, state: "visible" }), () => n(l, q.Unmount);
  }
  return { children: t, register: o, unregister: n };
}
let xt = Te.RenderStrategy, Ue = $({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: r, slots: n, expose: o }) {
  let l = b(0);
  function a() {
    l.value |= F.Opening, t("beforeEnter");
  }
  function i() {
    l.value &= ~F.Opening, t("afterEnter");
  }
  function s() {
    l.value |= F.Closing, t("beforeLeave");
  }
  function u() {
    l.value &= ~F.Closing, t("afterLeave");
  }
  if (!Vr() && pr())
    return () => x(St, { ...e, onBeforeEnter: a, onAfterEnter: i, onBeforeLeave: s, onAfterLeave: u }, n);
  let d = b(null), g = v(() => e.unmount ? q.Unmount : q.Hidden);
  o({ el: d, $el: d });
  let { show: c, appear: f } = Wr(), { register: p, unregister: m } = qr(), w = b(c.value ? "visible" : "hidden"), R = { value: !0 }, P = J(), G = { value: !1 }, fe = _t(() => {
    !G.value && w.value !== "hidden" && (w.value = "hidden", m(P), u());
  });
  L(() => {
    let H = p(P);
    M(H);
  }), N(() => {
    if (g.value === q.Hidden && P) {
      if (c.value && w.value !== "visible") {
        w.value = "visible";
        return;
      }
      z(w.value, { hidden: () => m(P), visible: () => p(P) });
    }
  });
  let ve = Y(e.enter), ee = Y(e.enterFrom), ge = Y(e.enterTo), me = Y(e.entered), Le = Y(e.leave), be = Y(e.leaveFrom), Oe = Y(e.leaveTo);
  L(() => {
    N(() => {
      if (w.value === "visible") {
        let H = T(d);
        if (H instanceof Comment && H.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function Pe(H) {
    let le = R.value && !f.value, I = T(d);
    !I || !(I instanceof HTMLElement) || le || (G.value = !0, c.value && a(), c.value || s(), H(c.value ? et(I, ve, ee, ge, me, (U) => {
      G.value = !1, U === Ie.Finished && i();
    }) : et(I, Le, be, Oe, me, (U) => {
      G.value = !1, U === Ie.Finished && (Se(fe) || (w.value = "hidden", m(P), u()));
    })));
  }
  return L(() => {
    ne([c], (H, le, I) => {
      Pe(I), R.value = !1;
    }, { immediate: !0 });
  }), j(Ge, fe), fr(v(() => z(w.value, { visible: F.Open, hidden: F.Closed }) | l.value)), () => {
    let { appear: H, show: le, enter: I, enterFrom: U, enterTo: te, entered: Ye, leave: Ke, leaveFrom: Xe, leaveTo: h, ...k } = e, A = { ref: d }, C = { ...k, ...f.value && c.value && de.isServer ? { class: ue([r.class, k.class, ...ve, ...ee]) } : {} };
    return D({ theirProps: C, ourProps: A, slot: {}, slots: n, attrs: r, features: xt, visible: w.value === "visible", name: "TransitionChild" });
  };
} }), Gr = Ue, St = $({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: r, slots: n }) {
  let o = Ve(), l = v(() => e.show === null && o !== null ? (o.value & F.Open) === F.Open : e.show);
  N(() => {
    if (![!0, !1].includes(l.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let a = b(l.value ? "visible" : "hidden"), i = _t(() => {
    a.value = "hidden";
  }), s = b(!0), u = { show: l, appear: v(() => e.appear || !s.value) };
  return L(() => {
    N(() => {
      s.value = !1, l.value ? a.value = "visible" : Se(i) || (a.value = "hidden");
    });
  }), j(Ge, i), j(qe, u), () => {
    let d = ft(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), g = { unmount: e.unmount };
    return D({ ourProps: { ...g, as: "template" }, theirProps: {}, slot: {}, slots: { ...n, default: () => [x(Gr, { onBeforeEnter: () => t("beforeEnter"), onAfterEnter: () => t("afterEnter"), onBeforeLeave: () => t("beforeLeave"), onAfterLeave: () => t("afterLeave"), ...r, ...g, ...d }, n.default)] }, attrs: {}, features: xt, visible: a.value === "visible", name: "Transition" });
  };
} });
const Yr = /* @__PURE__ */ y("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1), Kr = { class: "fixed inset-0 z-10 overflow-y-auto" }, Xr = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }, Qr = { class: "bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 dark:bg-zinc-800" }, Zr = { class: "sm:flex sm:items-start" }, Jr = { class: "mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" }, en = { class: "mt-2" }, tn = { class: "text-sm text-gray-500 dark:text-zinc-200" }, rn = { class: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 dark:bg-zinc-700" }, Hn = /* @__PURE__ */ $({
  __name: "TEModal",
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open"],
  setup(e) {
    return (t, r) => (E(), at(V(St), {
      as: "template",
      show: t.open
    }, {
      default: re(() => [
        K(V(Mr), {
          as: "div",
          class: "relative z-10",
          onClose: r[0] || (r[0] = (n) => t.$emit("update:open", !1))
        }, {
          default: re(() => [
            K(V(Ue), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: re(() => [
                Yr
              ]),
              _: 1
            }),
            y("div", Kr, [
              y("div", Xr, [
                K(V(Ue), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: re(() => [
                    K(V(Rr), { class: "relative overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg dark:bg-zinc-800" }, {
                      default: re(() => [
                        y("div", Qr, [
                          y("div", Zr, [
                            y("div", Jr, [
                              K(V(Hr), {
                                as: "h3",
                                class: "text-base font-semibold leading-6 text-gray-900 dark:text-zinc-50"
                              }, {
                                default: re(() => [
                                  S(t.$slots, "title")
                                ]),
                                _: 3
                              }),
                              y("div", en, [
                                y("p", tn, [
                                  S(t.$slots, "default")
                                ])
                              ])
                            ])
                          ])
                        ]),
                        y("div", rn, [
                          S(t.$slots, "actions")
                        ])
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), nn = {}, on = {
  "aria-label": "assertive",
  class: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
}, ln = /* @__PURE__ */ y("div", {
  id: "te-notifications",
  class: "flex w-full flex-col items-center space-y-4 sm:items-end"
}, null, -1), an = [
  ln
];
function sn(e, t) {
  return E(), _("div", on, an);
}
const un = /* @__PURE__ */ xe(nn, [["render", sn]]), dn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: un
}, Symbol.toStringTag, { value: "Module" }));
function cn(e, t) {
  return E(), _("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    y("path", { d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" })
  ]);
}
const pn = {
  key: 0,
  class: "dark:bg-zinc-750 pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 dark:ring-zinc-700"
}, fn = { class: "p-4" }, vn = { class: "flex items-start" }, gn = {
  key: 0,
  class: "mr-3 shrink-0"
}, mn = { class: "w-0 flex-1" }, bn = { class: "text-sm font-medium text-zinc-900 dark:text-white" }, hn = {
  key: 0,
  class: "mt-1 text-sm text-zinc-500 dark:text-zinc-100"
}, yn = {
  key: 1,
  class: "mt-3 flex space-x-7"
}, wn = {
  key: 1,
  class: "ml-4 flex shrink-0"
}, tt = /* @__PURE__ */ $({
  __name: "TENotification",
  props: {
    show: { type: Boolean },
    closeable: { type: Boolean },
    title: {},
    description: {},
    autoClose: { type: Boolean },
    color: {}
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const r = e, n = t, o = b(!1);
    let l;
    return L(() => {
      o.value = !0, Dt(() => {
        clearTimeout(l);
      });
    }), setTimeout(() => {
      n("update:show", !1);
    }, 2500), N(() => {
      r.autoClose && r.show ? typeof window < "u" && (l = window.setTimeout(() => {
        n("update:show", !1);
      }, 2500)) : l && clearTimeout(l);
    }), (a, i) => o.value ? (E(), at(lt, {
      key: 0,
      to: "#te-notifications"
    }, [
      K(At, {
        "enter-active-class": "transition duration-300 ease-out transform",
        "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
        "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
        "leave-active-class": "transition duration-100 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }),
      a.show ? (E(), _("div", pn, [
        a.autoClose ? (E(), _("div", {
          key: 0,
          class: ue(["te-notification-progress h-1", {
            "bg-green-500": a.color === "green",
            "bg-red-500": a.color === "red",
            "bg-primary-500": !a.color
          }]),
          style: { "animation-duration": "2500ms" }
        }, null, 2)) : B("", !0),
        y("div", fn, [
          y("div", vn, [
            a.$slots.icon ? (E(), _("div", gn, [
              S(a.$slots, "icon")
            ])) : B("", !0),
            y("div", mn, [
              y("p", bn, $e(a.title), 1),
              a.description || a.$slots.default ? (E(), _("p", hn, [
                S(a.$slots, "default", {}, () => [
                  nt($e(a.description), 1)
                ])
              ])) : B("", !0),
              a.$slots.actions ? (E(), _("div", yn, [
                S(a.$slots, "actions")
              ])) : B("", !0)
            ]),
            a.closeable ? (E(), _("div", wn, [
              y("button", {
                class: "size-4",
                type: "submit",
                onClick: i[0] || (i[0] = (s) => a.$emit("update:show", !1))
              }, [
                K(V(cn))
              ])
            ])) : B("", !0)
          ])
        ])
      ])) : B("", !0)
    ])) : B("", !0);
  }
}), zn = $({
  name: "TEFlashNotification",
  components: { TENotification: tt },
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: void 0
    },
    autoClose: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:show"],
  // eslint-disable-next-line vue/component-api-style
  render() {
    return x(tt, {
      show: this.show,
      "onUpdate:show": (e) => this.$emit("update:show", e),
      title: this.title,
      description: this.description,
      autoClose: !0
    });
  }
}), kn = {}, En = { class: "max-w-8xl bg-white w-full rounded-md shadow-xl dark:border-primary-400 dark:bg-zinc-800" }, $n = { class: "p-4 border-b" }, Tn = { class: "text-2xl font-medium" }, _n = {
  key: 0,
  class: "text-sm text-gray-500"
};
function xn(e, t) {
  return E(), _("div", En, [
    y("div", $n, [
      y("h2", Tn, [
        S(e.$slots, "title")
      ]),
      e.$slots.subtitle ? (E(), _("p", _n, [
        S(e.$slots, "subtitle")
      ])) : B("", !0)
    ]),
    y("div", null, [
      S(e.$slots, "default")
    ])
  ]);
}
const Sn = /* @__PURE__ */ xe(kn, [["render", xn]]), Ln = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sn
}, Symbol.toStringTag, { value: "Module" })), On = {}, Pn = { class: "md:grid md:grid-cols-2 hover:bg-gray-50 md:space-y-0 space-y-1 p-4 border-b dark:hover:bg-zinc-700" }, Fn = { class: "text-gray-600" };
function Dn(e, t) {
  return E(), _("div", Pn, [
    y("p", Fn, [
      S(e.$slots, "name")
    ]),
    y("p", null, [
      S(e.$slots, "default")
    ])
  ]);
}
const An = /* @__PURE__ */ xe(On, [["render", Dn]]), Cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: An
}, Symbol.toStringTag, { value: "Module" })), In = {
  install: (e) => {
    e.component("TEButton", Nt), e.component("TEBadge", () => import("./TEBadge-BjV_LW9q.js")), e.component("TEModal", () => import("./TEModal-Dubmh9rC.js")), e.component("TECard", () => Promise.resolve().then(() => Ut)), e.component(
      "TETopLabelLayout",
      () => import("./TETopLabelLayout-BYyBASiB.js")
    ), e.component(
      "TETextInput",
      () => import("./TETextInput-Diz4WxrW.js")
    ), e.component(
      "TENotificationHost",
      () => Promise.resolve().then(() => dn)
    ), e.component(
      "TENotification",
      () => import("./TENotification-D1JMMiaO.js")
    ), e.component(
      "TEFlashNotification",
      () => import("./TEFlashNotification-DIL_n4an.js")
    ), e.component(
      "TEDescriptionList",
      () => Promise.resolve().then(() => Ln)
    ), e.component(
      "TEDescriptionListItem",
      () => Promise.resolve().then(() => Cn)
    );
  }
};
export {
  Mn as TEBadge,
  Nt as TEButton,
  It as TECard,
  Sn as TEDescriptionList,
  An as TEDescriptionListItem,
  zn as TEFlashNotification,
  Hn as TEModal,
  tt as TENotification,
  un as TENotificationHost,
  Bn as TETextInput,
  jn as TETopLabelLayout,
  In as default
};
